import { render, staticRenderFns } from "./RegistrationDiscount.vue?vue&type=template&id=130e232a&scoped=true&"
import script from "./RegistrationDiscount.vue?vue&type=script&lang=ts&"
export * from "./RegistrationDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationDiscount.vue?vue&type=style&index=0&id=130e232a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e232a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
